<div class="ModalTabSubConPage">
    <h1>Life Style Changes</h1>

    <div class="possibleDiagnosis previewTabLeftContent diagnosis" [innerHtml]="lifestylechangesDataset"></div>

    </div>
